import { useHistory } from 'react-router-dom';
import Page from 'Shared/components/page/page';
import ErrorMessage from 'Shared/components/error-message';
import { useTranslation } from 'Shared/util/custom-hooks';


const NotFoundPage = () => {
  const history = useHistory();
  const t = useTranslation(x => x.notFound);
  const handleButtonClick = () => history.push('/');

  return (
    <Page
      title={{
        text: t.pageIsMissing,
        reducedMarginBottom: true,
      }}
    >
      <ErrorMessage
        text={t.pageYouTriedToReachCouldNotBeFound}
        buttonText={t.goToHomePage}
        onButtonClick={handleButtonClick}
      />
    </Page>
  );
};

export default NotFoundPage;
